import React, { useState, useEffect } from 'react';
import ReactApexChart from 'react-apexcharts';
import { Icon, Input, Button, Dropdown, Grid, Card, Popup, Segment, Tab, Table, Menu, Form, TextArea, Label, Header, Checkbox } from 'semantic-ui-react';
import { getkpidata, getkpidata1, getAgingDashboard, getkpidata3, getexceptiondata, getkpidata4, getexceptiondata1, getkpidata9, getexceptiondata2, getkpidatafin } from '../../../services/process/BRS/brsService';
import axios from "axios";
import { AgGridReact } from 'ag-grid-react';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';
import 'semantic-ui-css/semantic.min.css';
import Modal from 'react-bootstrap/Modal';
import * as XLSX from 'xlsx';
import RenderCard from "./card";



const DashboardComponent = () => {
  const [input1, setInput1] = useState('');
  const [input2, setInput2] = useState('');
  const [userCredentials] = useState(JSON.parse(sessionStorage.getItem("userCredentials")));
  const [seriesdonut, setseriesdonut] = useState();
  const [serieslabels, setserieslabels] = useState([]);
  const [seriesdata, setseriesdata] = useState([]);
  const [extGridData, setExtGridData] = useState([]);
  const [modelcolumnnames, setmodelcolumnnames] = useState([]);

  const [serieslabels1, setserieslabels1] = useState([]);
  const [seriesdata1, setseriesdata1] = useState([]);

  const [kpidata2, setkpidata2] = useState([]);
  const [approvedfunding, setapprovedfunding] = useState('');
  const [show, setShow] = useState(false);

  const [item, setitem] = useState({});
  const [item1, setitem1] = useState({});
  const [item2, setitem2] = useState({});
  const [item3, setitem3] = useState({});
  const [item4, setitem4] = useState('');
  const [item5, setitem5] = useState('');
  const [item6, setitem6] = useState('');
  const [item7, setitem7] = useState('');

  const [rejected, setrejected] = useState('');
  const [hold, sethold] = useState('');
  const [new1, setnew] = useState('');

  const [barwidth, setbarwidth] = useState('40%');
  const [userid, setuserid] = useState(userCredentials["user_id"]);


  const intColumnDefs3 = React.useMemo(() => {
    if (extGridData?.length > 0) {
      // Get the column names from the first row of the JSON data
      const keys = Object.keys(extGridData[0]);

      // Create column definitions with the checkbox as the first column
      const intColumnDefs = [

        ...keys.map((key) => ({
          headerName: key,
          field: key,
          sortable: true,
          filter: true,
          resizable: true
        })),
      ];
      setmodelcolumnnames(intColumnDefs);
      // console.log('intColumnDefs', intColumnDefs);
      return intColumnDefs;
    }
    return [];
  }, [extGridData]);


  function getKpiinfo3() {
    let payload = {
      'tenants_id': userCredentials["tenants_id"],
      'groups_id': userCredentials["groups_id"],
      'entities_id': userCredentials["entities_id"],
      'user_id': userCredentials["user_id"],

    }

    var getProcessingLayerDataWithStatus = getkpidata3();

    return axios.post(getProcessingLayerDataWithStatus[1], payload, getProcessingLayerDataWithStatus[0])
      .then(
        response => {
          console.log("Processing Layer Data With Status kpi info 1!!!", response)
          let data = response["data"];
          let data1 = data['outstanding_value'];
          setExtGridData(data1);
          setShow(true);
        }
      ).catch(
        error => {
          console.log("Error in Processing Layer Data WIth Status!!!", error);
        }
      );
  }

  function getKpiinfo4() {
    let payload = {
      'tenants_id': userCredentials["tenants_id"],
      'groups_id': userCredentials["groups_id"],
      'entities_id': userCredentials["entities_id"],
      'user_id': userCredentials["user_id"],

    }

    var getProcessingLayerDataWithStatus = getkpidata4();

    return axios.post(getProcessingLayerDataWithStatus[1], payload, getProcessingLayerDataWithStatus[0])
      .then(
        response => {
          console.log("Processing Layer Data With Status kpi info 1!!!", response)
          let data = response["data"];
          let data1 = data['outstanding_value'];
          setExtGridData(data1);
          setShow(true);
        }
      ).catch(
        error => {
          console.log("Error in Processing Layer Data WIth Status!!!", error);
        }
      );
  }

  const handleBarClick = (event, chartContext, config) => {
    console.log('clicked');
    getKpiinfo3();
  };

  const handleBarClick1 = (event, chartContext, config) => {
    console.log('clicked');
    getKpiinfo4();
  };

  const chartData1 = {
    series: [
      {
        name: 'Series 1',
        data: seriesdata,
      },
    ],
    options: {
      chart: {
        type: 'bar',
        height: 450,
      },
      plotOptions: {
        bar: {
          horizontal: false,
          endingShape: 'rounded',
          columnWidth: 30
        },
      },
      dataLabels: {
        enabled: false,
      },
      xaxis: {
        categories: serieslabels,
      },
      fill: {
        colors: ['#0a2352'],
      },
    },
  };

  const chartData2 = {
    series: [
      {
        name: 'Series 1',
        data: seriesdata1,
      },
    ],
    options: {
      chart: {
        type: 'bar',
        height: 450,
      },
      plotOptions: {
        bar: {
          horizontal: false,
          endingShape: 'rounded',
          columnWidth: barwidth,
        },
      },
      dataLabels: {
        enabled: false,
      },
      xaxis: {
        categories: serieslabels1,
      },
      fill: {
        colors: ['#0a2352'],
      },
    },
  };

  function getKpiinfo() {
    let payload = {
      'tenants_id': userCredentials["tenants_id"],
      'groups_id': userCredentials["groups_id"],
      'entities_id': userCredentials["entities_id"],
      'user_id': userCredentials["user_id"],

    }

    var getProcessingLayerDataWithStatus = getkpidatafin();

    return axios.post(getProcessingLayerDataWithStatus[1], payload, getProcessingLayerDataWithStatus[0])
      .then(
        response => {
          console.log("fin dashboard response", response)
          let data = response["data"];
          let arrays = data["data"];
          let array0 = arrays[0]
          let amount = array0[0].total_invoice_amount;
          const amountInLakhs = (amount / 100000).toFixed(2) + ' L';
          setInput1(amountInLakhs);
          let array1 = arrays[1]
          let amount1 = array1[0].total_invoice_amount;
          const amountInLakhs1 = (amount1 / 100000).toFixed(2) + ' L';

          setInput2(amountInLakhs1);
          let array2 = arrays[2]
          let funding_pending = array2[0].total_invoice_amount;
          const funding_pending1 = (funding_pending / 100000).toFixed(2) + ' L';
          setitem4(funding_pending1);
          // console.log('overdue', overdue);
          // let not_overdue = 100 - overdue;
          // const formattedNumber = overdue.toFixed(2);
          // setseriesdonut(formattedNumber);

          let array3 = arrays[3]
          let funding_pending2 = array3[0].total_invoice_amount;
          const funding_pending3 = (funding_pending2 / 100000).toFixed(2) + ' L';
          setapprovedfunding(funding_pending3);
          // const filteredData = array3.slice(0, 7);
          // console.log('filteredData', filteredData);
          // const dueDates = filteredData.map(item => item.due_date);
          // const invoiceAmounts = filteredData.map(item => item.total_invoice_amount);
          // setserieslabels(dueDates);
          // setseriesdata(invoiceAmounts);

          // let table_data = data["data1"];
          // setExtGridData(table_data);
          let percent_outstanding = parseFloat(amount1) / parseFloat(funding_pending2) * 100;
          setseriesdonut(percent_outstanding);
        }
      ).catch(
        error => {
          console.log("Error in Processing Layer Data WIth Status!!!", error);
        }
      );
  }


  function getagingdashboard() {
    let payload = {
      'tenants_id': userCredentials["tenants_id"],
      'groups_id': userCredentials["groups_id"],
      'entities_id': userCredentials["entities_id"],
      'user_id': userCredentials["user_id"],

    }

    var getProcessingLayerDataWithStatus = getAgingDashboard();

    return axios.post(getProcessingLayerDataWithStatus[1], payload, getProcessingLayerDataWithStatus[0])
      .then(
        response => {
          console.log("aging dashboard data!!!", response)
          let data = response["data"];
          let filteredData = data['outstanding_value'];
          const labels = filteredData.map(item => item.AgeBucket);
          const series = filteredData.map(item => item.TotalInvoiceAmount);
          setserieslabels1(labels);
          setseriesdata1(series);

          let arrayLength = [];
            let datesArray = labels;
            arrayLength = datesArray.length;

            if (arrayLength== 3){
              setbarwidth('40%')
            }else if(arrayLength== 2){
              setbarwidth('30%')
            }else if(arrayLength== 1){
              setbarwidth('10%')
            }
        }
      ).catch(
        error => {
          console.log("Error in Processing Layer Data WIth Status!!!", error);
        }
      );
  }



  function getKpiinfo1() {
    let payload = {
      'tenants_id': userCredentials["tenants_id"],
      'groups_id': userCredentials["groups_id"],
      'entities_id': userCredentials["entities_id"],
      'user_id': userCredentials["user_id"],

    }

    var getProcessingLayerDataWithStatus = getkpidata9();

    return axios.post(getProcessingLayerDataWithStatus[1], payload, getProcessingLayerDataWithStatus[0])
      .then(
        response => {
          console.log("Processing Layer Data With Status kpi info 1!!!", response)
          let data = response["data"];
          let data1 = data['outstanding_value'];
          let data2 = data['outstanding_value1'];
          let data3 = data['outstanding_value2'];
          let data4 = data['outstanding_value3'];
          let data5 = data['outstanding_value4'];
          let data6 = data['hold'];
          let data7 = data['reject'];
          let data8 = data['new'];

          let hold1 = data6[0]['total_invoice_amount']
          let reject1 = data7[0]['total_invoice_amount']
          let new2 = data8[0]['total_invoice_amount']
          hold1 = (hold1 / 100000).toFixed(2) + ' L';
          reject1 = (reject1 / 100000).toFixed(2) + ' L';
          new2 = (new2 / 100000).toFixed(2) + ' L';

          setrejected(reject1);
          sethold(hold1);
          setnew(new2);

          for (let item of data1) {
            if (item.Exception) {
              // Convert TotalInvoiceAmount to lakhs
              item.TotalInvoiceAmount = (item.TotalInvoiceAmount / 100000).toFixed(2) + ' L';
            }
          }

          for (let data in data1) {
            // console.log('data', data1[data]);
            if (data1[data]['Exception'] == "Dispute") {
              let item_1 = data1[data];
              setitem(item_1)

            }

            if (data1[data]['Exception'] == "Credit Note") {
              let item_2 = data1[data];
              setitem1(item_2)
            }

            if (data1[data]['Exception'] == "Debit Note") {
              let item_3 = data1[data];
              setitem2(item_3)
            }

            if (data1[data]['Exception'] == "Duplicate Invoice") {
              let item_4 = data1[data];
              setitem3(item_4)
            }
          }

          let pending = data2[0]['total_invoice_amount']
          let approved = data3[0]['total_invoice_amount']
          pending = (pending / 100000).toFixed(2) + ' L';
          approved = (approved / 100000).toFixed(2) + ' L';
          // setitem4(pending);
          setitem5(approved);
          let unallocated_credits = data4[0]['total_invoice_amount']
          let allocated_credits = data5[0]['total_invoice_amount']
          unallocated_credits = (unallocated_credits / 100000).toFixed(2) + ' L';
          allocated_credits = (allocated_credits / 100000).toFixed(2) + ' L';
          setitem6(unallocated_credits);
          setitem7(allocated_credits);

        }
      ).catch(
        error => {
          console.log("Error in Processing Layer Data WIth Status!!!", error);
        }
      );
  }


  function getKpiinfofunding() {
    let payload = {
      'tenants_id': userCredentials["tenants_id"],
      'groups_id': userCredentials["groups_id"],
      'entities_id': userCredentials["entities_id"],
      'user_id': userCredentials["user_id"],

    }

    var getProcessingLayerDataWithStatus = getkpidata();

    return axios.post(getProcessingLayerDataWithStatus[1], payload, getProcessingLayerDataWithStatus[0])
      .then(
        response => {
          console.log("Processing Layer Data With Status!!!", response)
          let data = response["data"];
          
          let arrays = data["data"];
         
          let array3 = arrays[3]
          let filteredData = array3.slice(0, 7);
          console.log('filteredData', filteredData);
          const dueDates = filteredData.map(item => item.due_dt);
          const invoiceAmounts = filteredData.map(item => item.total_invoice_amount);
          
          setserieslabels(dueDates);
          setseriesdata(invoiceAmounts);

          // let table_data = data["data1"];
          // setExtGridData(table_data);
        }
      ).catch(
        error => {
          console.log("Error in Processing Layer Data WIth Status!!!", error);
        }
      );
  }


  useEffect(() => {
    getKpiinfofunding();
    getKpiinfo();
    getKpiinfo1();
    getagingdashboard();
  }, []
  );



  const handleIconClick5 = () => {
    // Redirect to the desired URL
    window.location.href = '/ReconSummary'; // Replace with your URL
  };

  const handleClose = () => {

    setShow(false);
  }



  function getExceptiontypedata(exception) {
    let payload = {
      'tenants_id': userCredentials["tenants_id"],
      'groups_id': userCredentials["groups_id"],
      'entities_id': userCredentials["entities_id"],
      'user_id': userCredentials["user_id"],
      'exception': exception,

    }

    var getProcessingLayerDataWithStatus = getexceptiondata();

    return axios.post(getProcessingLayerDataWithStatus[1], payload, getProcessingLayerDataWithStatus[0])
      .then(
        response => {
          console.log("Processing Layer Data With Status kpi info 1!!!", response)
          let data = response["data"];
          let data1 = data['outstanding_value'];
          setExtGridData(data1);
          setShow(true);
        }
      ).catch(
        error => {
          console.log("Error in Processing Layer Data WIth Status!!!", error);
        }
      );
  }


  function getExceptiontypedata1(exception) {
    let payload = {
      'tenants_id': userCredentials["tenants_id"],
      'groups_id': userCredentials["groups_id"],
      'entities_id': userCredentials["entities_id"],
      'user_id': userCredentials["user_id"],
      'exception': exception,

    }

    var getProcessingLayerDataWithStatus = getexceptiondata2();

    return axios.post(getProcessingLayerDataWithStatus[1], payload, getProcessingLayerDataWithStatus[0])
      .then(
        response => {
          console.log("Processing Layer Data With Status kpi info 1!!!", response)
          let data = response["data"];
          let data1 = data['outstanding_value'];
          setExtGridData(data1);
          setShow(true);
        }
      ).catch(
        error => {
          console.log("Error in Processing Layer Data WIth Status!!!", error);
        }
      );
  }

  const getFirstcarddata = () => {
    getExceptiontypedata1('new')
  }

  const getFirstcarddata1 = () => {
    getExceptiontypedata1('hold')
  }

  const getFirstcarddata2 = () => {
    getExceptiontypedata1('rejected')
  }

  const getFirstcarddata3 = () => {
    getExceptiontypedata(item3.Exception)
  }

  const getFirstcarddata4 = () => {
    getExceptiontypedata1('approved funding closed')
  }

  const getFirstcarddata5 = () => {
    getExceptiontypedata1('approved funding open')
  }

  const getFirstcarddata6 = () => {
    getExceptiontypedata1('approved funding open')
  }

  const getFirstcarddata10 = () => {
    getExceptiontypedata1('Pending')
  }

  const getFirstcarddata11 = () => {
    getExceptiontypedata1('approved funding')
  }

  const getFirstcarddata12 = () => {
    console.log('called')
    getExceptiontypedata1('Unallocated Credits')
  }

  const getFirstcarddata13 = () => {
    getExceptiontypedata1('Allocated Credits')
  }

  function exportJsonToXLSX(data, sheetName, excelFileName) {
    try {
      var workBook = XLSX.utils.book_new();
      var workSheet = XLSX.utils.json_to_sheet(data, {
        skipHeader: false,
      });
      XLSX.utils.book_append_sheet(workBook, workSheet, sheetName);
      XLSX.writeFile(workBook, excelFileName);
      return true;
    }
    catch
    {
      return false;
    }
  }

  function exportToExcel() {
    let fileNameChange = "Report.xlsx";
    let sheetName = "sheet";

    let excelExportData = [];

    for (let i = 0; i < extGridData.length; i++) {
      let data = {};
      for (let key in extGridData[i]) {
        for (let j = 0; j < modelcolumnnames.length; j++) {
          if (key === modelcolumnnames[j]["field"]) {
            data[modelcolumnnames[j]["headerName"]] = extGridData[i][key]
          }
        }
      }

      excelExportData.push(data);
    };

    exportJsonToXLSX(excelExportData, sheetName, fileNameChange);

  }

  return (
    <>
          
      <Grid className="mt-2 mb-2" style={{ marginLeft: '1em' }}>
        <Grid.Row>
        {
            userid === 3 ? (<>
              <Grid.Column style={{ width: '23%' }} onClick={getFirstcarddata11}>
                    <RenderCard param1="Approved Funding" param2={approvedfunding} />
                  </Grid.Column>
            </>) : (<>
              <Grid.Column style={{ width: '23%' }} onClick={getFirstcarddata11}>
                    <RenderCard param1="Approved Funding" param2={approvedfunding} />
                  </Grid.Column>
            </>)}
          
                
          <Grid.Column style={{ width: '23%' }} onClick={getFirstcarddata4}>
            <RenderCard param1="approved funding closed" param2={input1} />

          </Grid.Column>

          <Grid.Column style={{ width: '22%' }} onClick={getFirstcarddata5}>
            <RenderCard param1="approved funding open" param2={input2} />

          </Grid.Column>
          <Grid.Column style={{ width: '21%' }} onClick={getFirstcarddata6}>
            <RenderCard param1="% of outstanding" param2={seriesdonut} />

          </Grid.Column>

          <Grid.Column style={{ width: '11%' }}>
            <div class="wrapper" style={{ paddingTop: '5em', height: '100%', width: '100%' }} >
              <div class="icon12 facebook" onClick={handleIconClick5}>
                <div class="tooltip">
                  Recon Summary
                </div>
                <span><i class="fa-solid fa-clipboard"></i></span>
              </div>
            </div>
          </Grid.Column>
        </Grid.Row>
      </Grid>

      {/* {
              userid === 1 ? (<>
                <Grid.Column onClick={getFirstcarddata1}>
                  <RenderCard param1="Debit Note" param2={item?.TotalInvoiceAmount} />

                </Grid.Column></>) : (<>
                  <Grid.Column onClick={getFirstcarddata13}>
                    <RenderCard param1="Allocated Credits" param2={item7} />

                  </Grid.Column></>)} */}

      

      <Grid className='mt-2 mb-2' style={{ marginLeft: '1em' }}>
        <Grid.Row>
          <Grid.Column style={{ width: '23%' }}>
            {
              userid === 3 ? (<>
                <Grid.Column onClick={getFirstcarddata2}>
                    <RenderCard param1="Funding Rejected" param2={rejected} />
                  </Grid.Column></>) : (<>
                    <Grid.Column onClick={getFirstcarddata10}>
                    <RenderCard param1="Pending Funding" param2={item4} />
                  </Grid.Column></>)}
            {
              userid === 3 ? (
                <>
                  <Grid.Column onClick={getFirstcarddata1}>
                  <RenderCard param1="Funding Held" param2={hold} />

                </Grid.Column>

                <Grid.Column onClick={getFirstcarddata}>
                <RenderCard param1="New Funding Request" param2={new1} /></Grid.Column>
                </>
              ) : (
                <>
                  <Grid.Column onClick={getFirstcarddata13}>
                    <RenderCard param1="Allocated Credits" param2={item7} />
                  </Grid.Column>

                  <Grid.Column onClick={getFirstcarddata12}>
                <RenderCard param1="Unallocated Credits" param2={item6} /></Grid.Column>
                </>
              )
            }

          </Grid.Column>

          <Grid.Column style={{ width: '38%' }}>

            <h3 style={{ color: '#3B5999' }}>Pending collections</h3>
            <ReactApexChart
              options={chartData1.options}
              series={chartData1.series}
              type="bar"
              height={350}
              onClick={handleBarClick1}
            />

          </Grid.Column>

          <Grid.Column style={{ width: '38%' }}>

            <h3 style={{ color: '#3B5999' }}>Ageing</h3>
            <ReactApexChart
              options={chartData2.options}
              series={chartData2.series}
              type="bar"
              height={350}
              onClick={handleBarClick}
            />

          </Grid.Column>

        </Grid.Row>
      </Grid>

      <Modal
        show={show}
        onHide={handleClose}
        backdrop="static"
        keyboard={false}
        size="lg"
      >
        <Modal.Header closeButton>
          <Modal.Title></Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className='row'>
            <div className='col-md-11'>

            </div>
            <div className='col-md-1'>
              <a onClick={exportToExcel}>
                <i class='fas fa-file-excel' style={{ fontSize: '30px', color: 'green' }}></i>
              </a>
            </div></div>
          <div className="ag-theme-alpine"
            style={{ height: '400px', width: '100%' }}
          >
            <AgGridReact
              columnDefs={modelcolumnnames}
              rowData={extGridData}
              animateRows={true}

              pagination={true}
              paginationPageSize={10}
            />
          </div>

        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default DashboardComponent;



